import { useId, useState } from "react";

import dompurify from "isomorphic-dompurify";

import { Button } from "@jti/core-components/components/Button";
import type { ConsentSectionConfiguration } from "@jti/fe-common";

import styles from "../ConsentBlock.module.scss";

const { sanitize } = dompurify;

type ConsentBenefitsListProps = {
  shortHtml: string;
  longHtml?: string;
} & Pick<ConsentSectionConfiguration, "showMoreBenefitsButtonLabel" | "showLessBenefitsButtonLabel">;

export const ConsentBenefitsList = ({
  shortHtml,
  longHtml,
  showLessBenefitsButtonLabel,
  showMoreBenefitsButtonLabel,
}: ConsentBenefitsListProps) => {
  const listContainerId = useId();
  const [isCollapsed, setIsCollapsed] = useState(true);

  const isButtonVisible = !!longHtml;

  const innerHtml = isCollapsed ? shortHtml : longHtml;
  const ctaLabel = isCollapsed ? showMoreBenefitsButtonLabel : showLessBenefitsButtonLabel;

  const handleClick = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <>
      <div
        id={listContainerId}
        className={styles.benefitsListWrapper}
        dangerouslySetInnerHTML={{ __html: sanitize(innerHtml ?? "") }}
      />
      {isButtonVisible && (
        <Button
          onClick={handleClick}
          variant="text"
          title={ctaLabel}
          className={styles.listCta}
          aria-expanded={!isCollapsed}
          aria-controls={listContainerId}
        >
          {ctaLabel ?? ""}
        </Button>
      )}
    </>
  );
};
